/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import { PhrMeasurement, PhrMeasurementFromJSON, PhrMeasurementFromJSONTyped, PhrMeasurementToJSON } from "./";

export const PhrGlucoseTypename = "PhrGlucose" as const;

/**
 *
 * @export
 * @interface PhrGlucose
 */
export interface PhrGlucose {
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrGlucose
   */
  other?: PhrMeasurement;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrGlucose
   */
  potentiometricMethod?: PhrMeasurement;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrGlucose
   */
  ultravioletVisibleAbsorptionSpectroscopy?: PhrMeasurement;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrGlucose
   */
  visibleAbsorptionSpectrophotometry?: PhrMeasurement;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrGlucose
   */
  readonly __typename?: string;
}

export function PhrGlucoseFromJSON(json: any): PhrGlucose {
  return PhrGlucoseFromJSONTyped(json, false);
}

export function PhrGlucoseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrGlucose {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrGlucoseTypename,

    other: !exists(json, "other") ? undefined : PhrMeasurementFromJSON(json["other"]),
    potentiometricMethod: !exists(json, "potentiometric_method")
      ? undefined
      : PhrMeasurementFromJSON(json["potentiometric_method"]),
    ultravioletVisibleAbsorptionSpectroscopy: !exists(json, "ultraviolet_visible_absorption_spectroscopy")
      ? undefined
      : PhrMeasurementFromJSON(json["ultraviolet_visible_absorption_spectroscopy"]),
    visibleAbsorptionSpectrophotometry: !exists(json, "visible_absorption_spectrophotometry")
      ? undefined
      : PhrMeasurementFromJSON(json["visible_absorption_spectrophotometry"]),
  };
}

export function PhrGlucoseToJSON(object?: PhrGlucose | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    other: PhrMeasurementToJSON(value.other),
    potentiometric_method: PhrMeasurementToJSON(value.potentiometricMethod),
    ultraviolet_visible_absorption_spectroscopy: PhrMeasurementToJSON(value.ultravioletVisibleAbsorptionSpectroscopy),
    visible_absorption_spectrophotometry: PhrMeasurementToJSON(value.visibleAbsorptionSpectrophotometry),
  };
}
